import { render, staticRenderFns } from "./DetailFooter.vue?vue&type=template&id=19d5c455&scoped=true"
import script from "./DetailFooter.vue?vue&type=script&lang=js"
export * from "./DetailFooter.vue?vue&type=script&lang=js"
import style0 from "./DetailFooter.vue?vue&type=style&index=0&id=19d5c455&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d5c455",
  null
  
)

export default component.exports